
import Vue from "vue";
import HeroBanner from "@/components/common/HeroBanner.vue";
import BreadCrumb from "@/components/common/BreadCrumb.vue";
import store from "@/store";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import { IBreadCrumbRoute } from "@/types";
import ContactusContent from "@/components/contact/ContactusContent.vue";
import TranProgramLowIncomeContent from "@/components/transPrograms/TransProgramLowIncomeIndContent.vue";
import LearnMore from "@/components/common/LearnMore.vue";

export default Vue.extend({
  name: "trans-program-low-income-ind",
  components: {
    HeroBanner,
    BreadCrumb,
    ContactusContent,
    TranProgramLowIncomeContent,
    LearnMore,
  },
  mixins: [UIFeatureMixin],
  data() {
    return {
      description:
        "Pennsylvania offers many transportation services to meet your needs.",
      routes: [
        { to: { name: "home" }, text: "Home" },
        {
          to: { name: "transProgramOverview" },
          text: "Transportation Programs",
        },
        {
          to: { name: "transProgramLowIncomeInd" },
          text: "Programs for Low Income Individuals",
        },
      ] as Array<IBreadCrumbRoute>,
    };
  },
  created() {
    let uiFeatureArray =
      "TPL_HERO_C,TPL_CON_1,TPL_CON_2,HME_THIS,NCOUNTY_1,NCOUNTY_2,NCOUNTY_3,AVAIL_CNTY,AVL_COUNTY,QUICK_SRCH,ER_INLINE,CHGLGN_TXT,ADMN_USR,MAIN,MAIN_TITLE,FMR,ENVRONMNT,ADA,FTP,MATP,PWD,SSR,CNTCT_US,CNT_US_C,LOW_INCOME,TPS_CNTCT,SEL_CNTY,FLT_CNTIES,TPL_LEARN";

    store.dispatch.uiFeatureModule.getUIFeatures(uiFeatureArray);
  },
  computed: {
    isDataLoading: {
      get(): boolean {
        return store.getters.uiFeatureModule.getLoadingStatus;
      },
    },
  },
});
